import React from 'react';
import './RewardReviewSkeletonLoader.css';
import TableSkeletonLoader from '../TableSkeletonLoader';

const RewardReviewSkeletonLoader = () => {
  return (
    <div
      className='reward-review-skeleton-container'
      data-testid='reward-review-skeleton-container'>
      <div
        className='reward-review-skeleton-breadcrumb'
        data-testid='reward-review-skeleton-breadcrumb'
      />

      <div className='reward-review-skeleton-header-row'>
        <div className='reward-review-skeleton-title' />
        <div className='reward-review-skeleton-title-actions'>
          <div
            className='reward-review-skeleton-button'
            data-testid='reward-review-skeleton-button'
          />
          <div
            className='reward-review-skeleton-button'
            data-testid='reward-review-skeleton-button'
          />
          <div
            className='reward-review-skeleton-button'
            data-testid='reward-review-skeleton-button'
          />
        </div>
      </div>

      <div className='reward-review-skeleton-subtitle-row'>
        <div className='reward-review-skeleton-subtitle' />
      </div>

      <div
        className='reward-review-skeleton-card'
        data-testid='reward-review-skeleton-card'>
        <div className='reward-review-skeleton-card-header' />
        <div className='reward-review-skeleton-grid-3'>
          {Array.from({length: 3}).map(() => (
            <div
              key={crypto.randomUUID()}
              className='reward-review-skeleton-kv'>
              <div className='reward-review-skeleton-label' />
              <div className='reward-review-skeleton-value' />
            </div>
          ))}
        </div>
        <div className='reward-review-skeleton-line' />
      </div>

      <div
        className='reward-review-skeleton-card'
        data-testid='reward-review-skeleton-card'>
        <div className='reward-review-skeleton-card-header' />
        <div className='reward-review-skeleton-grid-3'>
          {Array.from({length: 3}).map(() => (
            <div
              key={crypto.randomUUID()}
              className='reward-review-skeleton-kv'>
              <div className='reward-review-skeleton-label' />
              <div className='reward-review-skeleton-value' />
            </div>
          ))}
        </div>
        <div className='reward-review-skeleton-line' />
        <div className='reward-review-skeleton-line short' />
      </div>

      <div
        className='reward-review-skeleton-card'
        data-testid='reward-review-skeleton-card'>
        <div className='reward-review-skeleton-card-header' />
        <div className='reward-review-skeleton-table-header' />
        <TableSkeletonLoader rows={3} rowHeight={56} spacing={12} />
      </div>

      <div
        className='reward-review-skeleton-card'
        data-testid='reward-review-skeleton-card'>
        <div className='reward-review-skeleton-card-header' />
        <div className='reward-review-skeleton-grid-2'>
          {Array.from({length: 2}).map(() => (
            <div
              key={crypto.randomUUID()}
              className='reward-review-skeleton-kv'>
              <div className='reward-review-skeleton-label' />
              <div className='reward-review-skeleton-value' />
            </div>
          ))}
        </div>
      </div>

      <div className='reward-review-skeleton-footer-spacer' />
    </div>
  );
};

export default React.memo(RewardReviewSkeletonLoader);
